// extracted by mini-css-extract-plugin
export default {"link":"sOZ3q","menuName":"hJcGC","arrow":"ttmii"};